import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface DemoState {
  message: string;
  step: number;
  totalSteps: number;
}

const initialState: DemoState = {
  message: "",
  step: 0,
  totalSteps: 0,
};

const DemoSlice = createSlice({
  name: "Demo",
  initialState,
  reducers: {
    setCloningProgress: (state, action: PayloadAction<DemoState>) => {
      state.message = action.payload.message;
      state.step = action.payload.step;
      state.totalSteps = action.payload.totalSteps;
    },
  },
});

export const { setCloningProgress } = DemoSlice.actions;
export default DemoSlice.reducer;
